<template>
  <div>
    <v-snackbar
      v-model="message.snackbar"
      :timeout="message.snackbarTimeout"
      bottom
    >
      {{ message.snackbarText }}
      <v-btn dark text @click="message.snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-dialog v-model="createBookingDialog" max-width="800px">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title class="grey--text align-center"
            >Create new booking</v-toolbar-title
          >
          <div class="flex-grow-1"></div>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="formCreateBooking">
            <v-row>
              <v-col cols="12" md="6">
                <v-icon class="float-left py-4 pr-2" color="primary"
                  >person</v-icon
                >
                <v-text-field
                  filled
                  v-model="booking.firstname"
                  label="First name"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>

              <v-col cols="12" md="6">
                <v-text-field
                  filled
                  v-model="booking.lastname"
                  :rules="[rules.required]"
                  label="Last name"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12">
                <v-icon class="float-left py-4 pr-2" color="primary"
                  >email</v-icon
                >
                <v-text-field
                  filled
                  v-model="booking.email"
                  :rules="[rules.email, rules.required]"
                  label="Email"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12">
                <v-icon class="float-left py-4 pr-2" color="primary"
                  >email</v-icon
                >
                <v-text-field
                  filled
                  v-model="booking.confirmEmail"
                  :rules="[rules.confirmEmail, rules.required]"
                  label="Confirm email"
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="12">
                <v-icon class="float-left py-4 pr-2" color="primary"
                  >settings_cell</v-icon
                >
                <v-text-field
                  filled
                  v-model="booking.mobile"
                  label="Mobile number"
                  hint="for SMS confirmation"
                  v-mask="'##############'"
                  persistent-hint
                  required
                ></v-text-field>
              </v-col>
            </v-row>

            <div
              v-for="collectUserData in this.collectUserDatas"
              :key="collectUserData.id"
            >
              <v-row v-if="collectUserData.questionType !== 'PREQUESTION'">
                <v-col cols="12" md="12">
                  <v-icon
                    class="float-left py-4 pr-2"
                    v-if="collectUserData.fieldType !== 'checkbox'"
                    color="primary"
                    >mdi-pencil</v-icon
                  >
                  <v-text-field
                    class="hint"
                    persistent-hint
                    :hint="collectUserData.hint"
                    v-model="customField[collectUserData.fieldName]"
                    v-if="collectUserData.fieldType === 'text'"
                    filled
                    :rules="collectUserData.validation"
                    :label="collectUserData.label"
                    required
                  ></v-text-field>
                  <v-select
                    class="hint"
                    persistent-hint
                    :hint="collectUserData.hint"
                    v-model="customField[collectUserData.fieldName]"
                    v-if="collectUserData.fieldType === 'select'"
                    filled
                    :rules="collectUserData.validation"
                    :label="collectUserData.label"
                    :items="collectUserData.options"
                    required
                  ></v-select>
                  <v-checkbox
                    class="hint"
                    persistent-hint
                    :rules="collectUserData.validation"
                    :hint="collectUserData.hint"
                    v-model="customField[collectUserData.fieldName]"
                    v-if="collectUserData.fieldType === 'checkbox'"
                    :label="collectUserData.label"
                    value="true"
                  ></v-checkbox>
                </v-col>
              </v-row>
            </div>

            <v-btn
              depressed
              large
              class="managebookingsbutton hp--btn"
              @click="createBooking()"
              :loading="createBookingLoader"
              >Save</v-btn
            >
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div v-for="event in events" :key="event.id" style="margin-bottom: 15px">
      <v-card>
        <v-toolbar flat>
          <v-toolbar-title>
            {{ event.date | moment("Do MMMM YYYY") }},
            {{ event.room | capitalize }}
            <span class="grey--text" v-if="event.type !== 'register'"
              >({{ event.bookedCount }}/{{ event.slotCount }})</span
            >
          </v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-chip color="grey lighten-1" small>{{ event.code }}</v-chip>
          <v-chip
            v-if="event.status === 'Live'"
            class="ma-1"
            color="green darken-1"
            label
            small
            text-color="white"
            width="200"
          >
            <v-icon left small>mdi-play</v-icon>LIVE
          </v-chip>
          <v-chip
            v-if="event.status === 'Paused'"
            class="ma-1"
            color="blue"
            label
            small
            text-color="white"
            width="200"
          >
            <v-icon left small>mdi-pause</v-icon>PAUSED
          </v-chip>
          <v-chip
            v-if="event.status === 'Draft'"
            class="ma-1"
            color="orange"
            label
            small
            text-color="white"
            width="200"
          >
            <v-icon left small>mdi-pencil</v-icon>DRAFT
          </v-chip>
          <v-chip color="blue darken-2" class="white--text" label small>{{
            event.type | capitalize
          }}</v-chip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                dark
                small
                absolute
                bottom
                left
                fab
                v-on="on"
                @click="
                  booking = [];
                  booking.slotId = event.slotId;
                  createBookingDialog = !createBookingDialog;
                "
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <span>New workshop</span>
          </v-tooltip>

          <v-menu left bottom>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item @click="csvDownloadAll(events)">
                <v-list-item-title>CSV (ALL)</v-list-item-title>
              </v-list-item>
              <v-list-item @click="csvDownload(event.slot)">
                <v-list-item-title>CSV (SLOT)</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>

        <v-divider></v-divider>
        <v-data-table
          :items="event.slot"
          :headers="slotHeader"
          class="elevation-1"
          :sort-by="['time']"
          :sort-desc="[false]"
          :items-per-page="-1"
        >
          <template v-slot:item.attendance="{ item }">
            <v-checkbox
              @click="markAttendance(item)"
              v-model="item.attendance"
              hide-details
              class="shrink mt-0"
              :disabled="!item.booked || !event.attendance"
              v-if="item.type !== 'BREAK'"
              color="blue"
            ></v-checkbox>
          </template>
          <template v-slot:item.name="{ item }"
            >{{ item.firstname | capitalize }}
            {{ item.lastname | capitalize }}</template
          >
          <template v-slot:item.email="{ item }">
            <b v-if="item.type === 'BREAK' || item.type === 'BLOOD'">
              <span>{{ item.type }}</span>
            </b>
            <span v-else>{{ item.email }}</span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="success"
                  @click="onCreateBooking(item, event)"
                  >edit</v-icon
                >
              </template>
              <span>Update appointment</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" @click="cancelBooking(item)" color="error"
                  >delete</v-icon
                >
              </template>
              <span>Cancel appointment</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </div>
</template>
<script>
import { API, graphqlOperation } from "aws-amplify";
import { Booking } from "../classes/Booking";
import * as mutations from "./../graphql/mutations";
import moment from "moment";
export default {
  props: {
    events: Array
  },
  data() {
    return {
      booking: [],
      collectUserDatas: [],
      customField: {},
      createBookingDialog: false,
      createBookingLoader: false,
      message: {
        snackbar: false,
        snackbarText: "",
        snackbarTimeout: 3000
      },
      rules: {
        required: v => !!v || "This field is required.",
        email: v => /.+@.+\..+/.test(v) || "E-mail must be valid",
        confirmEmail: v =>
          v === this.booking.email || "Confirmation email must match email"
      },
      slotHeader: [
        { value: "attendance", align: "left", sortable: false, width: "25px" },
        { text: "Time", value: "time", align: "left" },
        { text: "Name", value: "name" },
        { text: "Email", value: "email" },
        { text: "Contact", value: "mobile" },
        { text: "Capacity", value: "capacity" },
        { value: "action", align: "right", sortable: false, width: "80px" }
      ]
    };
  },
  methods: {
    async onCreateBooking(slot, ev) {
      const that = this;
      this.createBookingDialog = true;

      this.booking = {
        id: slot.id,
        slotId: slot.slotId,
        time: slot.time,
        type: slot.type,
        firstname: slot.firstname,
        lastname: slot.lastname,
        email: slot.email,
        confirmEmail: slot.email,
        mobile: slot.mobile
      };
      const event = await Booking.getEvent(ev.code.toLowerCase());
      this.collectUserDatas = Booking.allCustomFields(event[0]);

      if (this.collectUserDatas.length > 0) {
        let customDataObj = {};
        this.collectUserDatas.forEach(function(userdata) {
          customDataObj[`${userdata.fieldName}`] = "";
        });
        that.customField = customDataObj;
        if (slot.customData) {
          let customDataObj = {};
          let customData = JSON.parse(slot.customData);
          for (const [key, value] of Object.entries(customData)) {
            customDataObj[`${key}`] = `${value}`;
          }
          that.customField = customDataObj;
        }
      }
    },
    async createBooking() {
      if (this.$refs.formCreateBooking.validate()) {
        const that = this;
        this.createBookingLoader = true;
        this.events.map(async (event, eventIndex) => {
          if (that.booking.slotId === event.slotId) {
            if (that.booking.id === undefined) {
              const booking = await Booking.createBookingWorkshop({
                firstname: this.booking.firstname,
                lastname: this.booking.lastname,
                email: this.booking.email,
                mobile: this.booking.mobile,
                dob: "",
                capacity: event.capacity,
                customData: this.customField,
                isDeleted: 0,
                eventBookingEventSlotId: that.booking.slotId
              });

              if (booking !== false) {
                /* NOTIFY USER OF BOOKING */
                await Booking.sendBookingEmail({
                  slotTime: booking.eventSlot.time,
                  eventDate: moment(booking.eventSlotGroup.date).format(
                    "YYYY-MM-DD"
                  ),
                  company: booking.company,
                  event: booking.event,
                  room: booking.eventSlotGroup.room,
                  firstname: booking.firstname,
                  lastname: booking.lastname,
                  email: booking.email,
                  phone: booking.mobile,
                  iCalendar: null, //this.event.iCalendar,
                  commsTemplateId: booking.commsTemplateId,
                  browser: this.$browserDetect.meta
                });

                Booking.sendTextMessage({
                  slotTime: booking.eventSlot.time,
                  mobile: booking.mobile,
                  event: booking.event.name,
                  eventDate: booking.eventSlotGroup.date,
                  firstname: booking.firstname,
                  lastname: booking.lastname,
                  room: booking.eventSlotGroup.room,
                  commsTemplateId: booking.commsTemplateId
                });

                event.slot.push({
                  id: booking.id,
                  cancelBooking: true,
                  customData: booking.customData,
                  firstname: booking.firstname,
                  lastname: booking.lastname,
                  mobile: booking.mobile,
                  email: booking.email,
                  iCalendar: booking.iCalendar,
                  isDeleted: 0,
                  booked: 1,
                  dob: "",
                  time: booking.eventSlot.time
                });
                event.bookedCount++;
              } else {
                this.showSuccessMessage(`All time slots have been taken`);
              }
              this.createBookingLoader = false;
              this.createBookingDialog = false;
            } else {
              event.slot.map(async (slot, slotIndex) => {
                let booking = [];
                if (that.booking.id === slot.id) {
                  booking = await Booking.updateBooking({
                    id: this.booking.id,
                    firstname: this.booking.firstname,
                    lastname: this.booking.lastname,
                    email: this.booking.email,
                    mobile: this.booking.mobile,
                    dob: "",
                    customData: this.customField,
                    isDeleted: 0,
                    eventBookingEventSlotId: this.booking.slotId
                  });

                  slot.id = booking.id;
                  slot.firstname = booking.firstname;
                  slot.lastname = booking.lastname;
                  slot.mobile = booking.mobile;
                  slot.email = booking.email;
                  slot.booked = 1;
                  slot.dob = null;
                  slot.customData = booking.customData;

                  this.showSuccessMessage(
                    `${booking.firstname} ${booking.lastname} workshop updated`
                  );

                  // Update table slot
                  slot.booked++;
                  this.createBookingLoader = false;
                  this.createBookingDialog = false;
                }
              });
            }
          }
        });
      }
    },
    async cancelBooking(booking) {
      const result = confirm(
        "Are you sure you want to cancel this appointment?"
      );

      if (result) {
        this.events.map((event, eventIndex) => {
          event.slot.map(async (slot, slotIndex) => {
            if (booking.id === slot.id) {
              await Booking.cancelBooking({
                bookingId: booking.id,
                slotId: null,
                iCalendar: event.iCalendar
              });

              this.events[eventIndex].slot.splice(slotIndex, 1);
              this.events[eventIndex].bookedCount--;
              // this.events[eventIndex].slotCount--;
            }
          });
        });
      }
    },
    csvExport(tableData) {
      const arrData = tableData;
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(arrData[0]).join(","),
        ...arrData.map(item => Object.values(item).join(","))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
    },
    csvDownload(download) {
      let bookingTableData = [];
      download.map((event, eventIndex) => {
        if (event.id) {
          bookingTableData.push({
            id: event.id,
            time: event.time,
            firstname: event.firstname,
            lastname: event.lastname,
            email: event.email,
            mobile: event.mobile,
            emailReminderSent: event.twentyFourHourReminder,
            attended: event.attendance === true ? "Yes" : "No"
          });
          let customData = JSON.parse(event.customData);
          if (customData) {
            let objectCustomDataKeys = Object.keys(customData);

            objectCustomDataKeys.forEach((data, index) => {
              let key = Object.keys(customData)[index];
              bookingTableData[bookingTableData.length - 1][key] =
                customData[Object.keys(customData)[index]];
            });
          }
        }
      });
      if (bookingTableData.length > 0) {
        this.csvExport(bookingTableData);
      } else {
        this.showSuccessMessage("No CSV results");
      }
    },
    csvDownloadAll(events) {
      let bookingTableData = [];
      events.map(event => {
        event.slot.map((slot, eventIndex) => {
          if (slot.id) {
            bookingTableData.push({
              // id: slot.id,
              date: moment(event.date).format("DD/MM/YYYY"),
              time: slot.time,
              firstname: slot.firstname,
              lastname: slot.lastname,
              email: slot.email,
              mobile: slot.mobile,
              dob: slot.dob,
              location: event.town,
              emailReminderSent: event.twentyFourHourReminder,
              attended: event.attendance === true ? "Yes" : "No"
            });

            let customData = JSON.parse(slot.customData);
            if (customData) {
              let objectCustomDataKeys = Object.keys(customData);
              objectCustomDataKeys.forEach((data, index) => {
                let key = Object.keys(customData)[index];
                bookingTableData[bookingTableData.length - 1][key] =
                  customData[Object.keys(customData)[index]];
              });
            }
          }
        });
      });
      if (bookingTableData.length > 0) {
        this.csvExport(bookingTableData);
      } else {
        this.showSuccessMessage("No CSV results");
      }
    },
    markAttendance(item) {
      API.graphql(
        graphqlOperation(mutations.updateEventBooking, {
          input: {
            id: item.id,
            attendance: item.attendance
          }
        })
      ).then(result => {
        const updateEventBooking = result.data.updateEventBooking;
        this.events.map((event, eventIndex) => {
          event.slot.map(async (slot, slotIndex) => {
            if (slot.id === updateEventBooking.id) {
              Object.assign(
                this.events[eventIndex].slot[slotIndex].attendance,
                updateEventBooking.attendance
              );
              if (updateEventBooking.attendance) {
                this.showSuccessMessage(
                  `${updateEventBooking.firstname} ${updateEventBooking.lastname} marked as attending`
                );
              } else {
                this.showSuccessMessage(
                  `${updateEventBooking.firstname} ${updateEventBooking.lastname} marked as NOT attending`
                );
              }
            }
          });
        });
      });
    },
    showSuccessMessage(message) {
      this.message.snackbarText = message;
      this.message.snackbar = true;
    }
  }
};
</script>
